import { formatDate } from '@/utils/dateFormatting';
import { SxProp, View } from 'dripsy';
import { Moment } from 'moment-timezone';
import React from 'react';
import { Icon } from '../icons/Icon';
import { TextCaption } from '../typography';

interface LastUpdatedProps {
  dateTime: string;
}

export const LastUpdated: React.FC<LastUpdatedProps> = ({ dateTime }) => {
  const formattedDate = formatDate(dateTime);

  return (
    <View sx={{ ...styles.container }}>
      <Icon name="lastUpdated" />
      <View sx={{ width: '$1' }} />
      <TextCaption
        secondary
        sx={{
          width: 'auto',
          color: '$textLastUpdated',
          // no breaks of any kind
          whiteSpace: 'nowrap'
        }}>
        {formattedDate}
      </TextCaption>
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    width: 'fit-content',
    flexDirection: 'row',
    alignItems: 'center'
  }
};
